import { WrapText } from "@material-ui/icons";
import { editor } from "monaco-editor";
import { useEffect, useState, useContext } from "react";
import { fetchPresignedUrl, uploadImage } from "../data/services/API";
import { useField } from "formik";
import { checkFormValidity } from "../utils/helpers";

import _ from "lodash";
import { Tooltip } from "@material-ui/core";
import * as Icons from "@material-ui/icons";
import { WorkflowErrors } from "../contexts/WorkflowErrors";

export default function (props) {
  const {
    waterMark,
    minHeight,
    handleEditorChange,
    id,
    name,
    label,
    taskReferenceName,
    imageUploadAPI,
    value,
    required,
    setCodeValue,
  } = props;
  const [tinymce, setTinymce] = useState(
    window?.tinymce ? window.tinymce : null
  );
  const [editorValue, setEditorValue] = useState("");
  const [field, meta] = useField(props);
  const [taskErrors, setTaskErrors] = useContext(WorkflowErrors);
  useEffect(() => {
    // function to check the validity of the field
    checkFormValidity(field, meta, props, taskErrors, setTaskErrors);
  }, [field, meta, props]);

  useEffect(() => {
    if (
      value &&
      tinymce?.get("wolkenEditor") &&
      !_.isEqual(editorValue, value)
    ) {
      tinymce.get("wolkenEditor").setContent(value);
    }
  }, [value]);

  useEffect(() => {
    if (tinymce) {
      tinymce.init({
        selector: "#wolkenEditor",
        license_key: "gpl",
        plugins:
          "accordion, advlist, anchor, autolink, autosave, autoresize, charmap, code, codesample, directionality, emoticons, fullscreen, image, importcss, insertdatetime, link, lists, media, nonbreaking, pagebreak, preview, quickbars, save, searchreplace, table, visualblocks, visualchars, wordcount",
        promotion: false,
        // statusbar: false,
        menubar: true,
        toolbar:
          "undo redo bold italic underline strikethrough superscript subscript link fullscreen | alignleft aligncenter alignright alignjustify |  styleselect fontselect fontsizeselect | bullist numlist | outdent indent |  forecolor backcolor | removeformat",
        default_link_target: "_blank",
        min_height: minHeight ? minHeight : 250,
        max_height: 450,
        // paste related options
        paste_data_images: true,
        // retain all the css when copied from outer source
        paste_webkit_styles: "all",
        // retain color and font from MS word
        paste_retain_style_properties:
          "font-size,font-family,font-weight,font-style,background,color",
        paste_merge_formats: false,
        // making this true will remove styles copied other editors
        paste_as_text: false,
        extended_valid_elements: "img[class|src|width|height|data]",
        style_formats_merge: false,
        remove_script_host: false,
        branding: false,
        width: "100%",
        end_container_on_empty_block: true,
        toolbar_drawer: "sliding",
        image_description: false,
        keep_styles: true,
        image_uploadtab: false,
        elementpath: false,
        toolbar_mode: "sliding",
        quickbars_insert_toolbar: "",
        placeholder: waterMark ? waterMark.replace("*", "") : "Description",
        setup: (editor) => {
          editor.on("input", (e) => {
            onInput(editor);
          });
          editor.on("change", (e) => {
            onContentChange(editor);
          });
          editor.on("init", (e) => {
            if (meta?.value) {
              editor.setContent(meta.value);
              setEditorValue(meta.value);
            }
          });
        },
      });
      return () => {
        tinymce.remove("#wolkenEditor");
      };
    }
  }, [tinymce]);

  useEffect(() => {
    let timeout;
    timeout = setTimeout(() => {
      handleEditorChange(editorValue);
    }, 500);

    return () => {
      clearTimeout(timeout);
    };
  }, [editorValue]);

  function onInput(editor) {
    setEditorValue(editor?.getContent() ? editor.getContent().trim() : "");
  }

  function onContentChange(editor) {
    const responseHTML = document.createElement("div");
    responseHTML.innerHTML = editor.getContent();
    var rawtext = editor.getContent({ format: "text" });
    if (responseHTML.childNodes.length > 0) {
      const imgElements = Array.from(responseHTML.getElementsByTagName("img"));
      let i = 0;
      if (imgElements.length > 0) {
        imgElements.forEach(async (ele, index) => {
          if (ele["src"] && ele["src"].startsWith("data:")) {
            let file = dataURLtoFile(ele["src"], "attachment.jpg"); // convert base 64 data to a file
            const formData = new FormData();
            formData.append("uploadFile", file, file.name);
            formData.append("data", JSON.stringify({ folderName: "Request" }));
            try {
              const uploadImageResponse = await uploadImage(
                imageUploadAPI
                  ? imageUploadAPI
                  : "attachment/upload_attachment",
                formData
              );
              if (uploadImageResponse.status === 200) {
                // upload each file and replace it in content
                i++;
                const uploadedImgElement = document.createElement(
                  this.imgReplaceElement
                );
                const presignedFormData = new FormData();
                let fileupload = uploadImageResponse["data"][
                  "attachmentDetails"
                ]
                  ? uploadImageResponse["data"]["attachmentDetails"]
                  : {};
                fileupload["attachmentTypeId"] = 2;
                this.fileArray.push(fileupload);
                this.inlineAttachments.emit(this.fileArray);
                presignedFormData.append(
                  "data",
                  JSON.stringify({
                    fileName:
                      uploadImageResponse["data"].attachmentDetails.fileName,
                  })
                );
                const fetchPresignedUrlResponse = await fetchPresignedUrl(
                  presignedFormData
                );
                if (fetchPresignedUrlResponse.status === 200) {
                  if (fetchPresignedUrlResponse?.data) {
                    const imgReplaceAttributes = [
                      {
                        attributeName: "src",
                        valueFrom: "RESPONSE",
                        valuePath: "data.preSignedURL",
                      },
                    ]; // config for attributes for replaced element
                    imgReplaceAttributes.forEach((customAttribute) => {
                      uploadedImgElement.setAttribute(
                        customAttribute.attributeName,
                        getValue(
                          fetchPresignedUrlResponse,
                          customAttribute,
                          ele
                        )
                      );
                    });
                    uploadedImgElement.setAttribute(
                      "data-image-identifier",
                      fetchPresignedUrlResponse.data.fileUrl
                    );
                    setEditorValue(
                      replaceNewElement(responseHTML, ele, uploadedImgElement)
                        .outerHTML
                    );
                    editor.setContent(
                      replaceNewElement(responseHTML, ele, uploadedImgElement)
                        .outerHTML
                    );
                  }
                  editor.selection.select(editor.getBody(), false);
                  editor.selection.collapse(false);
                }
              }
            } catch (err) {
              console.log("Error while uploading image", err);
            }
          } else {
            i++;
            if (
              !ele.dataset.hasOwnProperty("imageIdentifier") &&
              !ele["src"].includes("emoji")
            ) {
              contentPaste(editor);
            }
          }
        });
      } else {
        if (props.setCodeValue) {
          var rawHtml = editor.getContent();
          setCodeValue(name, rawHtml);
        }
      }
    }
  }

  function contentPaste(editor) {
    let domain = window.location.host;
    const imgReplaceAttributes = [
      {
        attributeName: "src",
        altValue: "alt",
        widthVal: "naturalWidth",
        heightVal: "naturalHeight",
        valueFrom: "RESPONSE",
        valuePath: "data.preSignedURL",
      },
    ];
    let file;
    let url;
    const responseHTML = document.createElement("div");
    responseHTML.innerHTML = editor
      ? editor.getContent()
      : this.editorControl.value;
    var rawtext = editor.getContent({ format: "text" });
    if (responseHTML.childNodes.length > 0) {
      const imgElements = Array.from(responseHTML.getElementsByTagName("img"));
      let i = 0;
      if (imgElements.length > 0) {
        imgElements.forEach(async (ele) => {
          if (
            ele["src"] &&
            (!ele["src"].includes("X-Amz-Security-Token") ||
              !ele["src"].includes(domain))
          ) {
            const toDataURL = (url) =>
              fetch(url)
                .then((response) => response.blob())
                .then((blob) =>
                  new Promise((resolve, reject) => {
                    // convert image src to base 64 data
                    const reader = new FileReader();
                    reader.onloadend = () => resolve(reader.result);
                    reader.onerror = reject;
                    reader.readAsDataURL(blob);
                  }).catch((err) => console.error("errorr", err))
                );

            toDataURL(ele["src"]).then(async (dataUrl) => {
              url = dataUrl;
              if (url.startsWith("data:")) {
                file = this.utilitiesService.dataURLtoFile(
                  dataUrl,
                  "attachment.jpg"
                ); // convert base 64 data to a file
                const formData = new FormData();
                formData.append("uploadFile", file, file.name);
                formData.append(
                  "data",
                  JSON.stringify({ folderName: "Request" })
                );
                try {
                  const uploadImageResponse = await uploadImage(
                    imageUploadAPI
                      ? imageUploadAPI
                      : "attachment/upload_attachment",
                    formData
                  );
                  if (uploadImageResponse.status === 200) {
                    // upload each file and replace it in content
                    i++;
                    const uploadedImgElement = document.createElement(
                      this.imgReplaceElement
                    );
                    const presignedFormData = new FormData();
                    presignedFormData.append(
                      "data",
                      JSON.stringify({
                        fileName:
                          uploadImageResponse["data"].attachmentDetails
                            .fileName,
                      })
                    );
                    const fetchPresignedUrlResponse = await fetchPresignedUrl(
                      presignedFormData
                    );
                    if (fetchPresignedUrlResponse.status === 200) {
                      if (
                        fetchPresignedUrlResponse &&
                        fetchPresignedUrlResponse.data
                      ) {
                        imgReplaceAttributes.forEach((customAttribute) => {
                          uploadedImgElement.setAttribute(
                            customAttribute.attributeName,
                            getValue(
                              fetchPresignedUrlResponse,
                              customAttribute,
                              ele
                            )
                          );
                        });
                        uploadedImgElement.setAttribute(
                          "data-image-identifier",
                          fetchPresignedUrlResponse.data.fileUrl
                        );
                        setEditorValue(
                          replaceNewElement(
                            responseHTML,
                            ele,
                            uploadedImgElement
                          ).outerHTML
                        );
                        editor.setContent(
                          replaceNewElement(
                            responseHTML,
                            ele,
                            uploadedImgElement
                          ).outerHTML
                        );
                      }
                      if (editor.selection) {
                        editor.selection.select(editor.getBody(), false);
                        editor.selection.collapse(false);
                      }
                    }
                  }
                } catch (err) {
                  console.log("Error while uploading image", err);
                }
              }
            });
          }
        });
      }
    }
  }

  function getValue(response, customAttribute, oldElement) {
    const value = customAttribute.valuePath;
    switch (customAttribute.valueFrom) {
      case "RESPONSE":
        let _value = "";
        const keyArray = value.split(".");
        let childData = response;
        keyArray.forEach((aKey) => {
          childData = childData[aKey];
          _value = childData;
        });
        return typeof _value === "object" ? JSON.stringify(_value) : _value;
      case "ELEMENT":
        return oldElement[value];
      case "DEFAULT":
        return value;
    }
  }

  function dataURLtoFile(dataurl, filename) {
    const arr = dataurl.split(","),
      mime = arr[0].match(/:(.*?);/)[1],
      bstr = atob(arr[1]);
    let n = bstr.length;
    const u8arr = new Uint8Array(n);
    while (n--) {
      u8arr[n] = bstr.charCodeAt(n);
    }
    return new File([u8arr], filename, { type: mime });
  }

  function replaceNewElement(
    parentElement,
    currentImgElement,
    uploadedImgElement,
    setSize = false
  ) {
    const nodes = Array.from(parentElement.childNodes);
    nodes.forEach((node) => {
      if (node.childNodes && node.childNodes.length > 0) {
        replaceNewElement(node, currentImgElement, uploadedImgElement, setSize);
      } else {
        if (node === currentImgElement) {
          if (setSize) {
            //first when we paste print screen images vertical scroll is not displaying
            const height = node["height"]
              ? node["height"]
              : currentImgElement["height"]
              ? currentImgElement["height"]
              : currentImgElement.style && currentImgElement.style.height
              ? currentImgElement.style.height
              : "250px";
            const width = node["width"]
              ? node["width"]
              : currentImgElement["width"]
              ? currentImgElement["width"]
              : currentImgElement.style && currentImgElement.style.width
              ? currentImgElement.style.width
              : "450px";
            uploadedImgElement.height = parseInt(height, 10);
            uploadedImgElement.width = parseInt(width, 10);
          }
          parentElement.replaceChild(uploadedImgElement, node);
        }
      }
    });
    return parentElement;
  }

  return (
    <div
      id={id}
      style={{ width: "100%", display: "flex", flexDirection: "column" }}
    >
      <div className="flex-row" style={{ alignItems: "center" }}>
        <label style={{ color: meta.error ? "red" : "" }}>
          {" "}
          {label}
          {required ? <span className="mandatory"> *</span> : ""}
        </label>
        {props.tooltip ? (
          <Tooltip title={props.tooltip} arrow>
            <Icons.Help
              style={{
                verticalAlign: "middle",
                fontSize: "16px",
                marginLeft: "5px",
                marginBottom: "5px",
              }}
              color="primary"
            />
          </Tooltip>
        ) : null}
      </div>
      <textarea id="wolkenEditor"></textarea>
      {meta.error ? (
        <div
          className="mt-25 ml-25 form_error-message"
          style={{ textAlign: "end" }}
        >
          {meta.error}
        </div>
      ) : null}
    </div>
  );
}
